<template>
  <div class="chart-scroll-container">
    <div class="chart-container" :style="{ width: chartWidth, position: 'relative', height: '350px' }">
      <canvas ref="chart" />
    </div>
  </div>
</template>
<script>
import { Chart } from 'chart.js'

export default {
  props: ['data', 'options', 'backgroundColor', 'scrollable'],
  data: () => {
    return {
      chart: null,
    }
  },
  computed: {
    chartWidth() {
      const labelCount = (this.data && this.data.labels && this.data.labels.length) || 0
      if (!this.scrollable || labelCount < 2) return '100%'

      return `max(100%, ${labelCount * 44 + 40}px)`
    },
  },
  watch: {
    data: {
      handler(newData) {
        this.chart.data = this.generateData(newData)
        this.chart.update()
      },
    },
  },
  mounted() {
    const ctx = this.$refs.chart.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: this.generateData(this.data),
      options: {
        ...this.options,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            padding: 7,
            caretSize: 8,
            bodyFont: {
              size: 20,
            },
            xAlign: 'left',
            yAlign: 'center',
            displayColors: false,
            callbacks: {
              title: function (_) {
                return null
              },
              label: function (context) {
                return context.dataset.tooltipLabels
                  ? context.dataset.tooltipLabels[context.dataIndex].split('|')
                  : context.formattedValue
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              drawBorder: false,
              title: false,
              display: false,
              color: '#F5F5F5',
            },
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              minRotation: 0,
              font: {
                family: 'Source Sans Pro',
                size: 16,
                weight: 400,
              },
              color: '#333333',
            },
          },
          y: {
            grid: {
              drawBorder: false,
              title: false,
              color: '#F5F5F5',
            },
            ticks: {
              stepSize: 2,
              font: {
                family: 'Source Sans Pro',
                size: 16,
              },
              color: '#333333',
            },
          },
        },
      },
    })
  },
  methods: {
    generateData(data) {
      return {
        ...data,
        datasets: data.datasets.map(set => ({
          backgroundColor: this.backgroundColor || '#F9D7CE',
          hoverBackgroundColor: this.backgroundColor || '#F9D7CE',
          barThickness: this.options.barThickness || 22,
          barPercentage: 100,
          ...set,
        })),
      }
    },
  },
}
</script>

<style scoped>
.chart-scroll-container {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  overflow-x: scroll;
  overscroll-behavior-x: contain;
  scrollbar-color: #979797 #f5f5f5;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  width: 100%;
}

.chart-scroll-container::-webkit-scrollbar {
  height: 8px;
}

.chart-scroll-container::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 8px;
}

.chart-scroll-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 8px;
}
</style>
